import styles from './SelectiveMultiModal.module.css';

/** Modal multi-selettiva PWA puro (browser-only, no wrapper RN).
 *  Mostra la prima della coda + frecce di navigazione. Si chiude
 *  automaticamente quando la lista pending e' vuota.
 *
 *  Estratto da GlobalSelectiveAlert per ridurne la dimensione. La logica di
 *  POST /respond (con gestione 409) vive in useSelectiveResponseHandler.
 *  Stili in SelectiveMultiModal.module.css. */

export interface PendingSelective {
  selectiveId: string;
  /** Tipo intervento ("Incendio", "Soccorso"...). NB: si chiama `selectiveType`
   *  e non `type` per allineamento al payload SignalR/FCM, dove `type` e' il
   *  discriminator dell'evento (`'selective.created'`) — vedi
   *  SelectiveCreatedPayload in shared/bridge. */
  selectiveType: string;
  zone?: string;
  priority?: string;
  callerInfo?: string;
  recipient?: string;
  notes?: string;
}

export function SelectiveMultiModal({
  pending, pendingIndex, setPendingIndex, respondToCurrent,
}: {
  pending: PendingSelective[];
  pendingIndex: number;
  setPendingIndex: (idx: number) => void;
  respondToCurrent: (accepted: boolean) => void;
}): React.JSX.Element {
  const safeIdx = Math.min(pendingIndex, pending.length - 1);
  const current = pending[safeIdx];
  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        {pending.length > 1 && (
          <div className={styles.navHeader}>
            <button
              onClick={() => setPendingIndex(Math.max(0, safeIdx - 1))}
              disabled={safeIdx === 0}
              className={styles.navBtn}>
              ◄
            </button>
            <strong className={styles.navCounter}>{safeIdx + 1} / {pending.length}</strong>
            <button
              onClick={() => setPendingIndex(Math.min(pending.length - 1, safeIdx + 1))}
              disabled={safeIdx === pending.length - 1}
              className={styles.navBtn}>
              ►
            </button>
          </div>
        )}
        <div className={styles.emoji}>🚨</div>
        <h2 className={styles.title}>SELETTIVA</h2>
        <div className={styles.type}>{current.selectiveType}</div>
        {current.priority && <div className={styles.detail}>⚡ Priorità: <strong>{current.priority}</strong></div>}
        {current.zone && <div className={styles.detail}>📍 Zona: <strong>{current.zone}</strong></div>}
        {current.callerInfo && <div className={styles.detail}>📞 {current.callerInfo}</div>}
        {current.recipient && <div className={styles.detail}>🎯 {current.recipient}</div>}
        {current.notes && <div className={styles.notes}>📝 {current.notes}</div>}
        <div className={styles.actions}>
          <button onClick={() => respondToCurrent(true)} className={`${styles.btn} ${styles.btnAccept}`}>
            ✓ ACCETTO
          </button>
          <button onClick={() => respondToCurrent(false)} className={`${styles.btn} ${styles.btnReject}`}>
            ✗ NON ACCETTO
          </button>
        </div>
      </div>
    </div>
  );
}
